<div class="row row_main">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 animate__animated animate__fadeIn" style="margin: 20px 0 80px 0">

        <app-detalle-inversion/>

    </div>
</div>